<template>
  <div>
    <list row-key="RecordId" ref="list" unit="商品信息" :page="page" :query-params="params" :show-checkbox="showCheckbox" :show-query="showQuery"
      :get-data-func="api.list" table-max-height="490px" >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="商品名称">
          <el-input v-model="params.GoodsName" placeholder="请输入商品名称" clearable />
        </el-form-item>
        <el-form-item label="商品品牌">
          <el-select v-model="params.BrandId" placeholder="请选择商品品牌" clearable>
            <el-option v-for="(i, k) in Brands" :key="k" :label="i.BrandName" :value="i.RecordId"></el-option>
          </el-select>
        </el-form-item>
      <!--  <el-form-item label="规格型号">
          <el-input v-model="params.GoodsModel" placeholder="请输入规格型号" clearable />
        </el-form-item>   -->
        <el-form-item label="规格型号">
          <el-input v-model="params.AttributeName" placeholder="请输入规格型号" clearable />
        </el-form-item>
        <el-form-item label="贸易模式">
          <el-select v-model="params.IfImport" placeholder="请选择贸易模式" clearable>
            <el-option label="跨境进口" :value="0"></el-option>
            <el-option label="一般贸易" :value="1"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="GoodsName" label="商品名称" min-width="300px" />
        <el-table-column prop="GoodsCode" label="商品编码" min-width="130px" />
        <el-table-column prop="AttributeName" label="规格型号" min-width="200px" show-overflow-tooltip />
        <el-table-column prop="TypeName" label="商品分类" min-width="130px" />
        <el-table-column prop="BrandName" label="商品品牌" min-width="130px" />
        <el-table-column prop="TradeMode" label="贸易模式" min-width="80px" align="center">
          <template slot-scope="{row}">
            <span>{{ row.TradeMode == 0 ? '跨境进口' : '一般贸易' }}</span>
          </template>
        </el-table-column>
      <!--  <el-table-column prop="GoodsModel" label="规格型号" min-width="120px" />  -->
        <el-table-column prop="MainUnitName" label="单位" min-width="100px" />
      <!--  <el-table-column prop="AuxiliaryUnitName" label="辅单位" min-width="100px" />   -->
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
export default {
  mixins: [listMixin],
  components: { list },
  props: {
    isMallGoods: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      api: require("@/api/goods/goodsattribute").default,
      brand_api: require("@/api/goods/brand").default,
      params: {
        GoodsName: "", //名称
        BrandId: null, //品牌
    //    GoodsModel: "", //规格型号
        AttributeName: "", //属性
        TradeMode: null, //贸易模式 - 0：跨境进口，1：是一般贸易
        State: 1, //状态 - 0：停用，1：正常
      },
      Brands: []
    };
  },
  mounted() {
    this.brand_api.list({ State: 1 }).then(res => {
      if (res.Code == 0) {
        this.Brands = res.Data;
      }
    })
  },
  methods: {},
};
</script>